import React from 'react';
import LogoKinetic from "../../images/logo-kinetic.svg";
import LogoDatassential from "../../images/logo-datassential.svg";
import './PageFooter.styles.scss';

function PageFooter () {
    return (
        <div className="page-footer">
            <div className="page-footer__inner">
                <div className="page-footer__left">
                    <div className="page-footer__text page-footer__copyright">© 2021 IFMA, All rights reserved</div>
                </div>
                <div className="page-footer__right">
                    <div className="page-footer__text">built in collaboration with:</div>
                    <a target="_blank" href='https://datassential.com' className="page-footer__img">
                        <LogoDatassential
                            width={115}
                            height={10}
                        />
                    </a>
                    <a target="_blank" href='https://kinetic12.com' className="page-footer__img">
                        <LogoKinetic width={40} height={20}/>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default PageFooter;